<template>
  <div class="ss-ItemSlider_Container swiper-container">
    <div class="ss-ItemSlider_Wrapper swiper-wrapper">
      <slot></slot>
    </div>
    <div v-if="scrollbar" ref="scrollbar" class="swiper-scrollbar" />
    <div v-if="pagination" ref="pagination" class="swiper-pagination" />
    <div v-if="arrows" ref="prev" class="ss-ItemSlider_IconWrapper ss-ItemSlider_IconWrapperPrev">
      <div class="ss-ItemSlider_IconContainer">
        <i class="fa fa-angle-left ss-ItemSlider_Icon-prev"></i>
      </div>
    </div>
    <div v-if="arrows" ref="next" class="ss-ItemSlider_IconWrapper ss-ItemSlider_IconWrapperNext">
      <div class="ss-ItemSlider_IconContainer">
        <i class="fa fa-angle-right ss-ItemSlider_Icon-next"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/js/swiper.min.js";
import { toPixel } from "../../utils/BreakPointMapper";
import { mapGetters } from "vuex";

export default {
  props: {
    slidesPerView: {
      type: [Number, Object],
      default: 1,
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    scrollbar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      instance: undefined,
      showNavigation: true,
    };
  },
  computed: {
    ...mapGetters({ productNameFilter: "lists/getProductNameFilter" }),
  },
  watch: {
    productNameFilter() {
      this.$nextTick(function() {
        this.addSwiperSlideClass();
        this.instance.update();
      });
    },
  },
  mounted() {
    this.instance = this.init();
  },
  beforeDestroy() {
    this.instance.destroy();
  },
  methods: {
    init() {
      if (this.$slots.default) {
        this.addSwiperSlideClass();
        return this.initSwiperInstance();
      }
    },
    addSwiperSlideClass() {
      this.$slots.default.forEach(vnode => {
        const element = vnode.elm;
        if (element.nodeType !== 8) { // CommentType for invisible Slides
          element.classList.add("swiper-slide");
        }
      });
    },
    initSwiperInstance() {
      let slidesPerView = 1;
      let breakpoints = {};

      if (typeof this.slidesPerView === "object") {
        const defaultKey = "default";
        slidesPerView = this.slidesPerView[defaultKey];

        Object.entries(this.slidesPerView).map(([breakpoint, slidesPerView]) => {
          if (breakpoint === defaultKey) {
            return;
          }

          const pixel = toPixel(breakpoint);

          if (!pixel) {
            return;
          }

          breakpoints[pixel] = {
            slidesPerView,
          };
        });
      }

      return new Swiper(this.$el, {
        slidesPerView: slidesPerView,
        spaceBetween: 10,
        freeMode: true,
        freeModeSticky: true,
        watchOverflow: true,
        scrollbar: {
          el: this.$refs.scrollbar,
          hide: true,
          draggable: true,
          dragClass: "swiper-scrollbar-drag",
        },
        pagination: {
          el: this.$refs.pagination,
          type: "bullets",
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
        },
        roundLengths: true,
        breakpoints,
      });
    },
  },
};
</script>
<style lang="scss">
@import "~swiper/css/swiper";
@import "~styles/global";

.ss-ItemSlider_Container.swiper-container {
  padding: $spacer / 4;
  margin-bottom: -$spacer;
  pointer-events: none;
}

.swiper-button-disabled {
  opacity: 0.5;
  transition: opacity $transition-duration-short;
}

.swiper-button-hidden {
  display: none !important;
}

.swiper-container > .swiper-button-lock {
  display: none !important;
}

.swiper-pagination {
  position: static;
  display: flex;
  justify-content: center;
  margin-top: $spacer / 2;
}

.swiper-pagination-bullet {
  display: block;
  margin: 0 2px;
  width: $spacer;
  height: $spacer / 4;
  border-radius: $border-radius;
  background: $gray-500;
  opacity: $opacity-half-visible;
}

.swiper-pagination-bullet-active {
  background: $gray-700;
  opacity: 1;
}

.ss-ItemSlider_Wrapper .swiper-slide {
  padding-bottom: $spacer;
}

.swiper-scrollbar-drag {
  cursor: grab;
}

.swiper-container-horizontal > .swiper-scrollbar {
  bottom: $spacer !important;
  pointer-events: all;
}

.ss-ItemSlider_IconWrapper {
  position: absolute;
  pointer-events: all;
  top: 40%;
  z-index: $zi-high;
  transform: translateY(-50%);
  border-radius: 50%;
  color: $secondary;
  transition-property: border-color, box-shadow, color;
  transition-duration: $transition-duration;
  background-color: $white;
  box-shadow: $box-shadow-sm;

  @include hover-states {
    color: $secondary;
    text-decoration: none;
    cursor: pointer;
    box-shadow: $box-shadow-sm-hover;
    outline: none;
  }
}

.ss-ItemSlider_IconContainer {
  display: inline-block;
  font-size: $width-slick-slider-icon / 2;
  line-height: $width-slick-slider-icon;
  width: $width-slick-slider-icon;
  height: $width-slick-slider-icon;
  text-align: center;
  vertical-align: bottom;

  @media (min-width: $screen-sm-min) {
    font-size: $width-slick-slider-icon-large / 2;
    line-height: $width-slick-slider-icon-large;
    width: $width-slick-slider-icon-large;
    height: $width-slick-slider-icon-large;
  }
}

.ss-ItemSlider_IconWrapperNext {
  right: $spacer / 2;
}

.ss-ItemSlider_IconWrapperPrev {
  left: $spacer / 2;
}

.ss-ItemSlider_Icon-next {
  margin-left: $border-radius;
}

.ss-ItemSlider_Icon-prev {
  margin-left: -$border-radius;
}
</style>
